import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';
import { SearchTbTipoCambioDto } from '~models/maestros-sync/SearchTbTipoCambioDto';
import { TbTipoCambio } from '~models/maestros-sync/TbTipoCambio';
import { ApiResponse } from '~shared/interface/ApiResponse';

@Injectable({
	providedIn: 'root',
})
export class TbTipoCambioService {
	private readonly _url = `${environment.HOST_MAESTROS_SYNC}/tbtipocambios`;
	constructor(protected _http: HttpClient) {}

	findByTmpDto(searchTbTipoCambioDto: SearchTbTipoCambioDto): Observable<TbTipoCambio> {
		return this._http
			.post<ApiResponse<TbTipoCambio>>(`${this._url}/findByTmpDto`, searchTbTipoCambioDto)
			.pipe(map((res) => res.data));
	}
	findLatestByMonedaAndFchCambio(
		searchTbTipoCambioDto: SearchTbTipoCambioDto
	): Observable<TbTipoCambio> {
		return this._http
			.post<ApiResponse<TbTipoCambio>>(
				`${this._url}/findLatestByMonedaAndFchCambio`,
				searchTbTipoCambioDto
			)
			.pipe(map((res) => res.data));
	}
}
